import PrintPageHeader from '../../components/header'
import { fetchDeltaColumnsPerDatasource, stats } from '../../printSlice'
import TrendPage from '../components/trendPageTemplate'
import { RootState } from '../../../rootReducer'
import { filterCurrentDayData } from '../../../utils/timeUtil'
import {
  getDeltaReportAggregation,
  getDeltaReportAggregationTableData,
  percentageDeltaCalculator
} from '../deltaReportUtil'
import dayjs from 'dayjs'
import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
interface IProps {
  fetchDeltaColumnsPerDatasource: (datasourceId: string) => void
  columnsperDs?: {
    [datasourceId: string]: stats[]
  }
  subText?: string
  datasourceId?: string
  datasourceName?: string
}
const SensitiveColumns = ({
  fetchDeltaColumnsPerDatasource,
  columnsperDs = {},
  subText,
  datasourceId = '',
  datasourceName
}: IProps): React.ReactElement => {
  useEffect(() => {
    datasourceId && fetchDeltaColumnsPerDatasource(datasourceId)
  }, [datasourceId, fetchDeltaColumnsPerDatasource])

  const historicalColumnStats = useMemo(() => {
    const dataSourceIds = Object.keys(columnsperDs)
    const startDataSourceId = dataSourceIds[0]
    let aggrData: stats[] = dataSourceIds.length ? columnsperDs[startDataSourceId] || [] : []
    dataSourceIds.forEach((dataSourceId) => {
      if (startDataSourceId !== dataSourceId) {
        const dataSourceData: stats[] = columnsperDs[dataSourceId]
        aggrData = aggrData.map((timeStampData) => {
          const data = dataSourceData.find(
            ({ endTimestamp, startTimestamp }) =>
              endTimestamp === timeStampData.endTimestamp &&
              startTimestamp === timeStampData.startTimestamp
          )
          const totalTimestampData = {
            endTimestamp: timeStampData.endTimestamp,
            startTimestamp: timeStampData.startTimestamp,
            total: (data?.total || 0) + (timeStampData.total || 0),
            added: (data?.added || 0) + (timeStampData.added || 0),
            deleted: (data?.deleted || 0) + (timeStampData.deleted || 0),
            startAdded: (data?.startAdded || 0) + (timeStampData.startAdded || 0),
            startDeleted: (data?.startDeleted || 0) + (timeStampData.startDeleted || 0),
            startTotal: (data?.startTotal || 0) + (timeStampData.startTotal || 0)
          }
          return totalTimestampData
        })
      }
    })

    return (datasourceId ? columnsperDs?.[datasourceId] : aggrData) || []
  }, [columnsperDs, datasourceId])

  const agreegatedColumnsStats = getDeltaReportAggregation(historicalColumnStats)
  const aggreegatedPercentageChange = percentageDeltaCalculator(
    agreegatedColumnsStats.startTotal,
    agreegatedColumnsStats.total
  )
  const columnsStats = filterCurrentDayData(historicalColumnStats)
  const chartData = columnsStats.map((stats) => {
    return {
      name:
        dayjs(stats.startTimestamp).format('D MMM') +
        ' - ' +
        dayjs(stats.endTimestamp).format('D MMM'),
      value: stats.total || 0
    }
  })
  const barData = columnsStats.map((stats) => {
    return {
      name:
        dayjs(stats.startTimestamp).format('D MMM') +
        ' - ' +
        dayjs(stats.endTimestamp).format('D MMM'),
      added: stats.added,
      deleted: stats.deleted
    }
  })
  const tableData = getDeltaReportAggregationTableData(columnsStats)

  return (
    <div className="sensitive-files delta-print-page" id={'sensitive-columns' + datasourceId}>
      <PrintPageHeader
        text={'Columns With Sensitive Data - All'}
        {...(subText
          ? { subText }
          : datasourceId
          ? {
              subText: (
                <>
                  Datasource: <strong>{datasourceName}</strong>
                </>
              )
            }
          : {})}
        {...(subText || datasourceId ? { className: 'align-horizontal' } : {})}
      />
      <TrendPage
        chartData={chartData || []}
        tableData={tableData}
        barData={barData || []}
        trendWidgetData={[
          {
            count: agreegatedColumnsStats.total,
            text: 'Current columns',
            percentage: aggreegatedPercentageChange
          },
          { count: agreegatedColumnsStats.added, text: 'Columns Added', bulletColor: '#13C2C2' },
          { count: agreegatedColumnsStats.deleted, text: 'Columns Deleted', bulletColor: '#CF1322' }
        ]}
        tableHeaders={['Date Range', 'Start of range', 'Added', 'Deleted', 'End of range']}
        legendText={'Columns with sensitive data'}
        areaTitleText="Trend for total columns with sensitive data"
        barTitleText="Delta changes for PII columns"
        barLegendPrefix="Columns"
      />
    </div>
  )
}
const mapStateToProps = (state: RootState) => ({
  columnsperDs: state.print.deltaColumnsPerDatasource
})

const mapDispatchToProps = {
  fetchDeltaColumnsPerDatasource
}

export default connect(mapStateToProps, mapDispatchToProps)(SensitiveColumns)
